module.exports = __webpack_public_path__ + "494cd07c/img/chevron-down-icon.5542f65c.svg";